

module.exports = __webpack_require__.stylable.create(
    "Price2328956720",
    {"classes":{"root":"Price2328956720__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Price2328956720",
    null
);
